import { withStyles } from "@material-ui/core";
import Tooltip from "../../../components/common/StyledToolTip";
import React from "react";
import ToggleRenderer from "../../../components/dataGrid/cellRenderer/toggleRenderer";
import styles from "./styles";

const CustomToggler = ({
  classes,
  title,
  tooltip,
  isEnabled,
  handleToggle,
  customClass,
}) => {
  return (
    <Tooltip title={tooltip}>
      <div
        className={`${customClass ? customClass : ""} ${
          classes.toggleAnimationButtonDispatchMap
        } glHeaderIcons`}
      >
        <div className={classes.toggleText}>{title}</div>
        <ToggleRenderer value={isEnabled} onChange={handleToggle} />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(CustomToggler);
